import React, { useMemo, forwardRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const ShippingLabelParcel = forwardRef(function ShippingLabelParcel(
  { box, invoice = null, exportAreaId = 'label-export-area' },
  ref
) {
  const codigoEtiqueta = useMemo(() => {
    if (!box) return '';
    return (
      box.codigo_pacote ||
      box.codigo ||
      box.codigo_rastreio ||
      ''
    ).toString();
  }, [box]);

  const dataRemessaDisplay = useMemo(() => {
    const raw =
      box?.data_remessa ||
      box?.data_criacao ||
      box?.created_at ||
      box?.updated_at ||
      invoice?.data ||
      invoice?.data_emissao ||
      invoice?.data_criacao ||
      invoice?.created_at;
    if (raw == null || raw === '') return null;
    try {
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return String(raw);
      return d.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return null;
    }
  }, [box, invoice]);

  if (!box) return null;

  return (
    <div ref={ref} id={exportAreaId} className="label-paper">
      <div className="label-parcel">
        <header className="label-parcel__head">
          <div className="label-parcel__head-left">
            <img
              src="/SENDING_TO.png"
              alt=""
              className="label-parcel__logo"
            />
            <div className="label-parcel__brand-wrap">
              <span className="label-parcel__brand">SendingTo Cargo Express</span>
              <span className="label-parcel__tagline">Etiqueta de envio — não dobrar</span>
            </div>
          </div>
          {dataRemessaDisplay ? (
            <div className="label-parcel__head-date">
              <span className="label-parcel__head-date-lbl">Data da Coleta</span>
              <span className="label-parcel__head-date-val">{dataRemessaDisplay}</span>
            </div>
          ) : null}
        </header>

        <div className="label-parcel__route">
          <div className="label-parcel__cell">
            <p className="label-parcel__cell-line">
              <span className="label-parcel__cell-lbl-inline">Origem:</span>
              <span className="label-parcel__cell-name">
                {box.origem || invoice?.origem || '—'}
              </span>
            </p>
          </div>
          <div className="label-parcel__cell label-parcel__cell--dest">
            <p className="label-parcel__cell-line">
              <span className="label-parcel__cell-lbl-inline">Destino:</span>
              <span className="label-parcel__cell-name">
                {box.destino || invoice?.destino || '—'}
              </span>
            </p>
          </div>
        </div>

        {codigoEtiqueta ? (
          <div className="label-parcel__track">
            <div className="label-parcel__track-inner">
              <div className="label-parcel__track-meta">
                <span className="label-parcel__track-lbl">Código do Pacote</span>
                <span className="label-parcel__code">{codigoEtiqueta}</span>
              </div>
              <div className="label-parcel__qr" aria-hidden="true">
                <QRCodeSVG
                  value={codigoEtiqueta}
                  size={400}
                  level="M"
                  includeMargin={true}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="label-parcel__track label-parcel__track--empty">
            <p className="label-parcel__missing">Código não disponível</p>
          </div>
        )}

        <footer className="label-parcel__foot">
          <p>Afixar de forma visível na embalagem. Manter legível.</p>
          <p>contato@sendingto.com</p>
        </footer>
      </div>
    </div>
  );
});

export default ShippingLabelParcel;
